import { axiosInstance } from "../../../api/axiosInstance";
import { Staff } from "../types";

export async function postStaff(data: Staff): Promise<number> {
  const response = await axiosInstance.post("/staff", data);
  return response.status;
}

export async function getStaffByType(staffType: string): Promise<Staff[]> {
  const response = await axiosInstance.get("/staff", {
    params: { role: staffType },
  });
  return response.data;
}